import { render } from "./TrackDashboard.vue?vue&type=template&id=c126e98a&scoped=true"
import script from "./TrackDashboard.vue?vue&type=script&lang=js"
export * from "./TrackDashboard.vue?vue&type=script&lang=js"

import "./TrackDashboard.vue?vue&type=style&index=0&id=c126e98a&lang=css"
import "./TrackDashboard.vue?vue&type=style&index=1&id=c126e98a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c126e98a"]])

export default __exports__